import { TitleChainReconciler } from './title-chain-reconciler';

export function TitleChainReconcilerPage() {
  return <TitleChainReconciler />;
}
